import React, { Component } from "react";
import firebase from "firebase/compat/app";

import "firebase/compat/auth";
import "./firebase-ui-auth.css";
import logo from "../../content/logo512.png";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
import { withRouter } from "react-router";
import { isAllreadyReviewed } from "../../parameter";

class SignInContainer extends Component {
    render() {
        return (
            <div>
                <div className="p-d-flex p-jc-center">
                    <img alt="Logo" width="100px" src={logo} />
                    <br />
                </div>
                <div className="p-d-flex p-jc-center p-text-center p-flex-column">
                   {isAllreadyReviewed && <> Bitte melden Sie sich an, um die Vollversion zu nutzen zu
                    können.</>}
                    <Divider></Divider>
                    <h3>Neues Konto erstellen</h3>
                    <Button
                        className="p-mb-2 p-ml-2 p-mr-2 "
                        onClick={() => {
                            var provider =
                                new firebase.auth.GoogleAuthProvider();
                            firebase
                                .auth()
                                .signInWithPopup(provider)
                                .then((result) => {
                                    this.props.history.push("/");
                                    window.location.reload();
                                })
                                .catch((error) => null);
                        }}
                    >
                        <i className="pi pi-google p-px-2"></i>
                        <span className="p-text-cente p-px-3">
                            Mit Google authentifizieren
                        </span>
                    </Button>
                    <Button
                        className="p-mb-2 p-ml-2 p-mr-2 "
                        onClick={() => {
                            this.props.history.push("/registrieren");
                        }}
                    >
                        <i className="pi pi-envelope p-px-2"></i>
                        <span className="p-text-cente p-px-3">
                            Mit E-Mail registrieren
                        </span>
                    </Button>
                    <Divider></Divider>
                    <h3>Mit vorhandenem Konto einloggen</h3>
                    <Button
                        className="p-mb-2 p-ml-2 p-mr-2 "
                        onClick={() => {
                            var provider =
                                new firebase.auth.GoogleAuthProvider();
                            firebase
                                .auth()
                                .signInWithPopup(provider)
                                .then((result) => {
                                    this.props.history.push("/");
                                    window.location.reload();
                                });
                        }}
                    >
                        <i className="pi pi-google p-px-2"></i>
                        <span className="p-text-cente p-px-3">
                            Mit Google authentifizieren
                        </span>
                    </Button>
                    <Button
                        className="p-mb-2 p-ml-2 p-mr-2 "
                        onClick={() => {
                            this.props.history.push("/login/email");
                        }}
                    >
                        <i className="pi pi-envelope p-px-2"></i>
                        <span className="p-text-cente p-px-3">
                            Mit E-Mail einloggen
                        </span>
                    </Button>
                </div>
            </div>
        );
    }
}
export const SignIn = SignInContainer;
export default withRouter(SignInContainer);
